export const defaultStyle = {
    videoWrapper: "VideWrapOneNews rleative",
    videoframe: "videoframe   px-10 lg:px-0",
    videoItem:
        "md:min-h-[399px] lg:min-h-[640px] min-h-[200px] lg:rounded-[30px] rounded-[20px] w-full",
    showImg: "w-full h-full ",
    hideImg: "hidden",
}



export const RECIPE_VIDEO = {
    videoframe: "px-10 lg:px-0 lg:w-[615px] lg:h-[346px] mx-auto my-[72px]",
    videoItem:
        "md:min-h-full lg:min-h-full min-h-full lg:rounded-[30px] rounded-[20px]",
}
export const videoSlider = {
    playButton:
        "absolute bg-arrowBg top-[40%] left-[45%] rounded-full md:mt-[15%] lg:mt-auto",
    showImg: "w-full h-full ",
    hideImg: "hidden",
    videoFrame:
        "lg:h-[403px] videoCrsl w-[100%] child:rounded-20 lg:h-full child:w-full child:mx-auto child:my-0 mb-10",
    videoFrameHide:
        "lg:px-10 lg:px-0 lg:h-[405px] w-[720px] child:rounded-20 child:h-full w-full child:mx-auto child:my-0 pb-10 max-w-full flex",
}
export const NEWSPAGE_DETAIL_VIDEO = {
    videoWrapper: "VideWrapForDetaail",
    playButton:
        "absolute  top-[40%] left-[45%] rounded-full md:mt-[0] lg:mt-auto !w-auto max-w-[120px] max-h-[120px] max-[767px]:w-[60px] max-[767px]:h-[60px]",
    showImg: "w-full h-full ",
    hideImg: "hidden",
    videoFrame:
        "videoCrsl w-[100%] child:rounded-20 h-full child:w-full child:mx-auto child:my-0 mb-10 [&>div]:h-[100%] max-[767px]:h-[303px]",
    videoFrameHide:
        "lg:px-10 lg:px-0 lg:h-[405px] w-[720px] child:rounded-20 child:h-full w-full child:mx-auto child:my-0 pb-10 max-w-full flex",
}

export const FULL_WIDTH_VIDEO_WRPR = {

    playButton:
        "absolute bg-arrowBg top-[40%] left-[45%] rounded-full md:mt-[15%] lg:mt-auto",
    showImg: "w-full h-full ",
    hideImg: "hidden",
    videoFrame:
        "lg:h-[403px] videoCrsl w-[100%] child:rounded-20 lg:h-full child:w-full child:mx-auto child:my-0 mb-10",
    videoFrameHide:
        "lg:px-10 lg:px-0 lg:h-[405px] w-[720px] child:rounded-20 child:h-full w-full child:mx-auto child:my-0 pb-10 max-w-full flex",
}


export const TWO_COL_6_WIDTH = {
    videoWrapper: "videoWrapper relative mb-[20px]  w-full h-auto", //h-[301px]
    playButton: "absolute rounded-full md:mt-[0] lg:mt-auto w-[60px] h-[60px] lg:w-[115px] lg:h-[115px]", // bg-arrowBg - removed for Procurement Supplier-Central-Portal cs
    showImg: "absolute w-full h-full flex items-center justify-center",
    playBtnImg: 'playBtnImg w-full h-full object-cover',
    hideImg: "hidden",
    videoFrame: "lg:h-[403px] videoCrsl md:w-[650px] md:h-[369px] md:child:w-[650px] md:child:h-[369px]  h-[182px]  child:rounded-20 lg:h-full  child:mx-auto child:my-0 mb-10 w-full child:h-[182px] max-w-[100%] [&>div]:max-w-[100%]",
    videoFrameHide: "lg:px-10 lg:px-0 h-[182px] w-[320px] md:w-[650px] md:h-[369px] md:child:w-[650px] md:child:h-[369px]   child:rounded-20 child:h-[182px] md:child:min-h-[340px]  w-full child:mx-auto child:my-0 pb-10 max-w-full flex",
}

export const TWO_COL_6_WIDTH_IMAGE_CONTAIN = {
    videoWrapper: "videoWrapper relative mb-[20px]  w-full h-auto", //h-[301px]
    playButton: "absolute rounded-full md:mt-[0] lg:mt-auto w-[60px] h-[60px] lg:w-[115px] lg:h-[115px]", // bg-arrowBg - removed for Procurement Supplier-Central-Portal cs
    showImg: "absolute w-full h-full flex items-center justify-center",
    playBtnImg: 'playBtnImg w-full h-full object-contain',
    hideImg: "hidden",
    videoFrame: "lg:h-[403px] videoCrsl md:w-[650px] md:h-[369px] md:child:w-[650px] md:child:h-[369px]  h-[182px]  child:rounded-20 lg:h-full  child:mx-auto child:my-0 mb-10 w-full child:h-[182px] max-w-[100%] [&>div]:max-w-[100%]",
    videoFrameHide: "lg:px-10 lg:px-0 h-[182px] w-[320px] md:w-[650px] md:h-[369px] md:child:w-[650px] md:child:h-[369px]   child:rounded-20 child:h-[182px] md:child:min-h-[340px]  w-full child:mx-auto child:my-0 pb-10 max-w-full flex",
}

export const TWO_COL_6_WIDTH_HOMEPAGE = {
    ...TWO_COL_6_WIDTH,
    playBtnImg: 'playBtnImg w-full h-full object-contain', 
}

export const QUARTER_WIDTH_VIDEO_WRPR = {
    ...TWO_COL_6_WIDTH,
    videoWrapper: "videoWrapper relative w-auto lg:h-[223px] md:h-[190px] ",
    videoFrameHide: " h-full lg:w-[397px] lg:h-[223px] child:rounded-20 child:h-full lg:child:min-h-[223px] w-full child:mx-auto child:my-0 pb-10 max-w-full flex md:min-w-[215px] child:w-[215px] md:min-h-[120px] child:h-[120px] h-[120px] w-[215px] hidden md:block",
    playButton: "absolute bg-arrowBg rounded-full md:mt-[0] lg:mt-auto hidden md:block",
    playBtnImg: 'playBtnImg  lg:h-[223px] lg:w-[397px] hidden md:block ',
    showImg: "absolute w-full h-auto flex items-center justify-center lg:h-[223px] lg:w-[397px] md:h-[122px]  ",
    videoFrame: "videoCrsl QuaterVideo w-[100%] child:rounded-20 child:w-full  child:my-0 mb-10 lg:min-h-[223px] lg:w-[397px] lg:child:min-h-[223px] lg:child:w-[397px] md:min-w-[215px] md:min-h-[190px] md:child:min-h-[190px]   ",
}

export const FULL_WIDTH = {
    videoWrapper: "videoWrapper relative mb-[10px] md:h-auto w-full mx-auto",
    playButton: "absolute rounded-full md:mt-[0] lg:mt-auto w-[115px] h-[115px]",
    showImg: "relative w-full flex items-center justify-center",
    playBtnImg: 'playBtnImg w-full h-full',
    hideImg: "hidden",
    videoFrame: "videoCrsl w-[100%] child:rounded-20 lg:h-full child:w-full child:mx-auto child:my-0 mb-10",
    videoFrameHide: "lg:px-10 lg:px-0 h-full w-[720px] child:rounded-20 child:h-full md:child:min-h-[340px] w-full child:mx-auto child:my-0 pb-10 max-w-full flex",
}
export const CAREER_VIDEO_BANNER = {
    videoWrapper: "careerVideoBanner videoWrapper relative md:h-auto w-full md:[&>div>iframe]:!h-[422px] lg:[&>div>iframe]:!h-full",
    playButton: "absolute rounded-full md:mt-[0] lg:mt-auto w-[115px] h-[115px]",
    showImg: "relative w-full flex items-center justify-center",
    playBtnImg: 'playBtnImg w-full h-full',
    hideImg: "hidden",
    videoFrame: "videoCrsl w-[100%] child:rounded-20 lg:h-full child:w-full child:mx-auto child:my-0 mb-10",
    videoFrameHide: "lg:px-10 lg:px-0 h-full w-[720px] child:rounded-20 child:h-full md:child:min-h-[340px] w-full child:mx-auto child:my-0 pb-10 max-w-full flex",
}
export const THREE_COL_VIDEO_WRAP = {
    videoWrapper: ' videotest videoWrapper relative w-full lg:px-[15px]',
    playBtnImg: "relative VideoImg h-[335px] object-cover",
    playButton: "twoVideoplayBtn absolute top-[50%] left-[50%] -translate-x-[50%] -translate-y-[50%]",
}
export const VIDEO_WITH_IMAGE_WITH_TEXT = {
    videoWrapper: " videoinTabContent",
    videoframe: "videoframe   px-10 lg:px-0",
    videoItem:
        "md:min-h-[399px] lg:min-h-[640px] min-h-[200px] lg:rounded-[30px] rounded-[20px] w-full",
    showImg: "w-full h-full ",
    hideImg: "hidden",
    playBtnImg: "btn-img",
    playButton: "playing-btn absolute translate-x-[-50%] left-[50%] top-[50%] translate-y-[-50%]"
}


